export default __webpack_public_path__ + "static/media/individual_course_2.e0b920aa.jpg";